import React from "react"
import Icon from "app/static/frontend/components/Icon"

import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

export interface SponsorCellProps {
    children?: string
}

export const SponsorCell = ({ children, ...props }: SponsorCellProps) => (
    <CellWrapper className="sponsor-cell" {...props}>
        {children ? (
            <div className="sponsor-cell-content">
                <Icon name={DjangIO.app.bill.models.SponsorType.by_value(parseInt(children, 10)).icon} />
                {DjangIO.app.bill.models.SponsorType.by_value(parseInt(children)).label}
            </div>
        ) : (
            ({ children } as any)
        )}
    </CellWrapper>
)
